import { IconGift } from 'featherico';
import { useEffect } from 'react';
import { MenuLink, MenuSeparator } from '../../../components/DropdownMenu';
import { getActiveReleaseNotes } from '../service';
import styles from './style.m.less';

interface Props {
    now: Date;
    lastViewed: Date;
    onHide: () => void;
}

export function JustLaunchedMenuItems({ now, lastViewed, onHide }: Props) {
    useEffect(() => onHide, [onHide]);
    return (
        <>
            <MenuSeparator />
            <MenuLink href="https://www.small-improvements.com/release-notes" openInNewTab>
                <IconGift /> What's New
            </MenuLink>
            {getActiveReleaseNotes(now.getTime()).map(releaseNote => {
                const isNew = new Date(releaseNote.date).getTime() > lastViewed.getTime();
                return (
                    <MenuLink
                        key={releaseNote.menuItem}
                        href={releaseNote.href}
                        openInNewTab
                        className={isNew ? styles.menuItemNew : styles.menuItem}
                    >
                        <span className={styles.dotContainer}>
                            <span className={styles.dot} />
                        </span>{' '}
                        {releaseNote.menuItem}
                    </MenuLink>
                );
            })}
        </>
    );
}
